import { useLocation } from "react-router-dom";

export const usePathAndData = () => {
    const location = useLocation();

    // Dividir la URL en partes
    const path = location.pathname.split("/");

    // Extraer el valor de "data" del query string
    const searchParams = new URLSearchParams(location.search);
    const dataValue = searchParams.get("data"); // Extrae el valor de "data"

    return { path, dataValue };
};
